var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-row justify-content-center"},[_c('img',{attrs:{"src":require("..//assets/loading.gif"),"width":"400"}})])}]

export { render, staticRenderFns }